import { render, staticRenderFns } from "./linkedinAccount.vue?vue&type=template&id=1c6084da&scoped=true&"
import script from "./linkedinAccount.vue?vue&type=script&lang=js&"
export * from "./linkedinAccount.vue?vue&type=script&lang=js&"
import style0 from "./linkedinAccount.vue?vue&type=style&index=0&id=1c6084da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6084da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c6084da')) {
      api.createRecord('1c6084da', component.options)
    } else {
      api.reload('1c6084da', component.options)
    }
    module.hot.accept("./linkedinAccount.vue?vue&type=template&id=1c6084da&scoped=true&", function () {
      api.rerender('1c6084da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/profile/linkedinAccount.vue"
export default component.exports